<template>
    <div>
        <a-modal v-model="visible" title="Yapi" @ok="handleOk" width="1000px">
            <a-input placeholder="输入Yapi 项目ID 默认为 1361" v-model="yapiID" style="width:200px;margin-right:20px;" /> 
            <a-button type="primary" @click="handleYapiIn">接入yapi</a-button> 
            <a-tabs default-active-key="1" style="padding-top:10px;">
                <a-tab-pane key="1361" tab="对外开放平台接口">
                </a-tab-pane>
            </a-tabs>
            <a-table :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange ,type:rowsType}"
                :columns="columns" :data-source="datalist" :pagination="true" rowKey="_id" :loading="tableLoading"
                :expanded-row-keys.sync="expandedRowKeys" />
        </a-modal>
    </div>
</template>
<script>
const columns = [
    {
        title: '接口名',
        dataIndex: 'title',
        align: 'left',
    },
    {
        title: '地址',
        dataIndex: 'path',
        align: 'left',
    },
];
export default {
    data() {
        return {
            columns,
            rowsType:'radio',
            selectedRowKeys: [],
            datalist:[],
            visible: false,
            expandedRowKeys: [],
            dataSource:[],
            tableLoading:false,
            yapiID:"1361"
        };
    },
    methods: {
        handleYapiIn(){
            if(!this.yapiID){
                this.message.info("请输入YapiID");
                return;
            }
            localStorage.setItem('searchYapiIDStore',this.yapiID)

            this.showModal(this.yapiID)
        },
        onSelectChange(selectedRowKeys) {
            this.selectedRowKeys = selectedRowKeys;
        },
        showModal(yapiID) {
            if(!yapiID){
                yapiID = localStorage.getItem('searchYapiIDStore')
                this.yapiID = yapiID = yapiID ? yapiID : '1361'
            }
            let that = this;
            this.tableLoading = true;
            this.visible = true;
            this.$store.dispatch({
                type: "open/yapilist",
                params: {
                    projectcode:yapiID,
                    urlparams:false,
                },
                showMsg: false
            }).then((res) => {
                that.datalist = [];
                that.dataSource = [];
                if(res.status == 200 && res.data.success == '1'){
                    let target = res.data.data.data;
                    if(typeof(target) == 'string'){
                        target = JSON.parse(target);
                    }
                    if(target.length > 0){
                        target.forEach(element => {
                            element.title = element.name;
                            element.path = ''
                            element.children = element.list;
                            that.expandedRowKeys.push(element._id)
                            that.dataSource = that.dataSource.concat(element.list)
                        });
                        this.datalist = target;
                    }
                }
                this.tableLoading = false;
            }).catch(() => {
                this.tableLoading = false;
            });
        },
        handleOk() {
            let that = this;
            let current_keys = this.selectedRowKeys;
            let result = [];
            for (let index = 0; index < current_keys.length; index++) {
                const element = current_keys[index];
                let c_item = that.dataSource.filter(function(n){
                    return element == n._id
                });
                if(c_item.length == 0){
                    result = []
                    break;
                }
                result.push(c_item[0])
            }
            this.$emit('handleSelected',result[0]._id);
            this.selectedRowKeys = [];
            this.visible = false;
        },
    },
};
</script>
